import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const alertShown = useRef(false);

  useEffect(() => {
    if (!user && !alertShown.current) {
      alertShown.current = true;
      alert('로그인이 필요합니다.');
      navigate('/');
    }
  }, [user, navigate]);

  if (!user) return null;

  return children;
};

export default ProtectedRoute;

